type VatCode = {
  id: string;
  code?: string;
  label: string;
  scope?: 'unknown' | 'nat' | 'eu' | 'int';
  rate: number;
  type: 'unknown' | 'sale' | 'purchase' | 'both';
  deductible_account?: string;
  payable_account?: string;
};

enum JournalTypes {
  unknown = 'unknown',
  customer_invoice = 'customer_invoice',
  customer_refund = 'customer_refund',
  supplier_invoice = 'supplier_invoice',
  supplier_refund = 'supplier_refund',
  financial_operation = 'financial_operation',
  miscellaneous_operation = 'miscellaneous_operation',
}

type Journal = {
  id: string;
  code?: string;
  name: string;
  type: JournalTypes;
  journal_type: JournalTypes;
};

type FolderData = {
  vatCodes: VatCode[];
  journals: Journal[];
  id: string;
  name: string;
  selected?: boolean | undefined;
};

enum IntegrationSlug {
  HORUS_CHIFT = 'horus-chift',
  OCTOPUS_CHIFT = 'octopus-chift',
  EXACT_CHIFT = 'exact-chift',
  PEPPOL = 'peppol',
  ODOO_CHIFT = 'odoo-chift',
  YUKI_CHIFT = 'yuki-chift',
  WINBOOKS_CHIFT = 'winbooks-chift',
}

/** Slugs exposed as Accountable Connect for the majority (exclude from "request access" modal). */
export const ACCOUNTABLE_CONNECT_INTEGRATION_SLUGS: IntegrationSlug[] = [
  IntegrationSlug.EXACT_CHIFT,
  IntegrationSlug.HORUS_CHIFT,
  IntegrationSlug.ODOO_CHIFT,
  IntegrationSlug.OCTOPUS_CHIFT,
];

enum ChiftIntegrationStatus {
  AUTHORIZATION_REQUIRED = 'authorization_required',
  AUTHORIZED = 'authorized',
  DISCONNECTED = 'disconnected',
  AVAILABLE = 'available',
  ACTIVE = 'active',
  WAITING_CALLBACK = 'waiting_callback',
}

enum CategoryMappedFrom {
  LLM_GUESSED = 'llm_guessed',
  BY_ACCOUNTANT_FOR_USER = 'by_accountant_for_user',
  BY_ACCOUNTANT_FOR_OTHER_USERS = 'by_accountant_for_other_users',
}

type ChiftIntegrationType = {
  icon_url: string;
  integrationId: string;
  logo_url: string;
  slug: IntegrationSlug;
  status: ChiftIntegrationStatus | string;
  type: string;
  _id: string;
  isConnected?: boolean;
  metaData: {
    expenseVATCodes: any;
    revenueVATCodes: any;
  };
  workspaceId: string;
};

type AccountingCategory = {
  categoryId: string;
  chiftAccountNumber: string;
  mappedFrom: CategoryMappedFrom;
  required: boolean;
};

interface IChiftLink {
  _id: string;
  integrationId: string;
  folderId: string;
  created: string;
  modified: string;
  userId: string;
  workspaceId: string;
}

export {
  VatCode,
  Journal,
  FolderData,
  IntegrationSlug,
  ChiftIntegrationType,
  JournalTypes,
  ChiftIntegrationStatus,
  CategoryMappedFrom,
  AccountingCategory,
  IChiftLink,
};
